import { css } from 'styled-components';
import { colors } from '../../colors';

export const TexterThemeTemplate = {
  TexterContainer: css``,
  TexterLabel: css``,
  TexterSubLabel: css``,
  TexterInput: css``,
  TexterSlot: css``,
  TexterError: css``,
};

export const ClassroomsDefaultTheme = {
  TexterContainer: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 20px 0;
  `,
  TexterLabel: css`
    font-size: 16px;
    font-weight: bold;
    color: #4A4A4A;
    letter-spacing: 0;
    line-height: 21px;
    text-transform: none;
  `,
  TexterSubLabel: css``,
  TexterInput: css`
    background-color: white;
    border: 1px solid ${colors.shadeMedium};
    border-radius: 8px;
    height: 40px;
    padding: 10px 20px;
    box-sizing: border-box;

    font-size: 16px;
    font-weight: normal;
    color: #4A4A4A;
    letter-spacing: 0;

    &:focus {
      color: ${colors.newKinedu};
      border: 1px solid ${colors.newKinedu};
    }

    ::-webkit-input-placeholder {
      overflow: visible;
      color: ${colors.shadeMedium};
    }
    ::-moz-placeholder {
      overflow: visible;
      color: ${colors.shadeMedium};
    }
    ::-ms-placeholder {
      overflow: visible;
      color: ${colors.shadeMedium};
    }
    ::placeholder {
      overflow: visible;
      color: ${colors.shadeMedium};
    }

    &.error {
      border: 1px solid #EF4B48;
    }
  `,
  TexterSlot: css``,
  TexterError: css`
    margin-top: 5px;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #EF4B48;
  `,
};

interface IThemes {
  [key: string]: any;
}

const OptionerThemes: IThemes = {
  TexterThemeTemplate,
  ClassroomsDefaultTheme,
};

export default OptionerThemes;
